import { z } from "zod";

/**
 * `POST /reports/users/activity` — what each sending user sent per day, what is queued
 * next, and the caps those numbers run against.
 */
const dayCounts = z.record(z.string(), z.coerce.number());

export const UserActivityCapsSchema = z.object({
	linkedinInvites: z.coerce.number(),
	linkedinMessages: z.coerce.number(),
	linkedinVisits: z.coerce.number(),
	emails: z.coerce.number(),
});

export type UserActivityCaps = z.infer<typeof UserActivityCapsSchema>;

export const UserActivityGridSchema = z.object({
	userId: z.number(),
	name: z.string(),
	caps: UserActivityCapsSchema,
	/** metric → day → count */
	sent: z.record(z.string(), dayCounts),
	scheduled: z.record(z.string(), dayCounts),
});

export type UserActivityGrid = z.infer<typeof UserActivityGridSchema>;

export const UserActivitySchema = z.object({
	past: z.array(z.string()),
	future: z.array(z.string()),
	users: z.array(UserActivityGridSchema),
	/** Company-wide: `usage` carries no userId, so this cannot be split per user. */
	creditSpendByDay: dayCounts,
});

export type UserActivity = z.infer<typeof UserActivitySchema>;
